export interface INewModelRequest {
  newModelRequestID: number
  statusID: number
  vehicleMakeID: number
  customerID: number
  noOfSeat: number
  vehicleModelName: string
  requestDate: string
  vehicleMakeName: string
  customerName: string
  mobileNumber: string
  email: string
}

export const newModelRequestInitValue: INewModelRequest = {
  newModelRequestID: 0,
  statusID: 0,
  vehicleMakeID: 0,
  customerID: 0,
  noOfSeat: 0,
  vehicleModelName: '',
  requestDate: '',
  vehicleMakeName: '',
  customerName: '',
  mobileNumber: '',
  email: '',
}
